import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _, { chain, partial, split } from 'lodash';

import { PATH } from '../../../../constants/path';
import { APP_NAME, HIDE_HEADER } from '../../../../constants';
import { VALIDATED } from '../../../../services/checkout/constants';
import { COOKIE_KEY_EMAIL } from '../../../../constants/cookie';

import { getI18nByApp } from '../../../../services/i18n/selector';
import { getPartner } from '../../../../services/partner/selector';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import Stepper from '../Stepper';
import { Logo } from '../../../icons/Logo';
import HeadComponent from '../../../HeadComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import ConfirmationEbonPageKycBloc from './kyc/ConfirmationEbonPageKycBloc';
import ConfirmationEbonPageMessageBloc from './message/ConfirmationEbonPageMessageBloc';
import ConfirmationEbonPageStateController from './ConfirmationEbonPageStateController';

import { Template } from '../../../template/TemplateStyle';
import { HeaderNav } from '../../../header/HeaderNavComponentStyle';
import { ConfirmationEbonPageContainer } from './ConfirmationEbonPageStyle';
import { Header, HeaderGlobalStyle } from '../../../header/HeaderComponentStyle';

const ConfirmationEbonPage = ({
    i18n,
    orderId,
    paypalCost,
    paymentRef,
    checkoutSessionId,
    checkoutPaymentId,
    fetchingOrder,
    confirmedOrder,
    partnerId,
    partnerName
}) => {
    const [loading, setLoading] = useState(false);
    const [kyc, setKyc] = useState(false);
    const [kycValidated, setKycValidated] = useState(false);
    const [ebonOrderState, setEbonOrderState] = useState(null);
    const [detailsInterval, setDetailsInterval] = useState(null);

    const sessionEmail = sessionStorage.getItem(COOKIE_KEY_EMAIL) || '';

    // un retour Apple Pay / Google Pay peut arriver sans paramètre cko-* : l'état de la commande est aussi accepté
    const isOrderValidated = () =>
        ebonOrderState === VALIDATED || (!!confirmedOrder && confirmedOrder.state === VALIDATED);

    return (
        <Template className="flex-container-v">
            <ConfirmationEbonPageStateController
                orderId={orderId}
                partnerId={partnerId}
                partnerName={partnerName}
                checkoutSessionId={checkoutSessionId}
                checkoutPaymentId={checkoutPaymentId}
                paypalCost={paypalCost}
                paymentRef={paymentRef}
                setLoading={setLoading}
                setKyc={setKyc}
                kycValidated={kycValidated}
                ebonOrderState={ebonOrderState}
                setEbonOrderState={setEbonOrderState}
                detailsInterval={detailsInterval}
                sessionEmail={sessionEmail}
            />

            <HeaderNav className="entete minimal" id="entete">
                <div className="flex-container-v">
                    <Header className="tetedepage conteneur flex-container-h flex-center-alt">
                        <HeaderGlobalStyle />
                        {!HIDE_HEADER && (
                            <LocalizedNavLink to={PATH.HOME_PATH} title={APP_NAME} className="logo">
                                <Logo />
                            </LocalizedNavLink>
                        )}
                        <Stepper steps={getI18nByApp(i18n, 'page.EBON.STEPS')} current={4} />
                    </Header>
                </div>
            </HeaderNav>
            <ConfirmationEbonPageContainer className="conteneur conteneur-mobile">
                <HeadComponent
                    title={getI18nByApp(i18n, 'page.EBON.CONFIRMATION.TITLE')}
                    description={getI18nByApp(i18n, 'page.EBON.DESCRIPTION')}
                />
                <Stepper
                    steps={getI18nByApp(i18n, 'page.EBON.STEPS')}
                    current={4}
                    cssClass="mobileDisplay"
                />

                <div className="congratulation-container">
                    {loading && !kycValidated && (
                        <React.Fragment>
                            <LoadingComponent />
                            <p className="pending-message">
                                {convertHtmlToReactDomWithParams(
                                    getI18nByApp(i18n, 'page.EBON.CONFIRMATION.PENDING_MESSAGE')
                                )}
                            </p>
                        </React.Fragment>
                    )}

                    <ConfirmationEbonPageKycBloc
                        orderId={orderId}
                        checkoutSessionId={checkoutSessionId}
                        checkoutPaymentId={checkoutPaymentId}
                        paypalCost={paypalCost}
                        paymentRef={paymentRef}
                        fetchingOrder={fetchingOrder}
                        ebonOrderState={ebonOrderState}
                        kyc={kyc}
                        setKyc={setKyc}
                        kycValidated={kycValidated}
                        setKycValidated={setKycValidated}
                        detailsInterval={detailsInterval}
                        setDetailsInterval={setDetailsInterval}
                    />

                    {!kyc && !loading && isOrderValidated() && (
                        <ConfirmationEbonPageMessageBloc
                            partnerId={partnerId}
                            partnerName={partnerName}
                            sessionEmail={sessionEmail}
                            confirmedOrder={confirmedOrder}
                            ebonOrderState={ebonOrderState}
                        />
                    )}
                </div>
            </ConfirmationEbonPageContainer>
        </Template>
    );
};

const mapStateToProps = (state, ownProps) => {
    const search = ownProps.location.search;
    const params =
        search &&
        chain(search)
            .replace('?', '') // a=toto
            .split('&') // ["a=toto","c=bobo","f=coco"]
            .map(partial(split, _, '=', 2)) // [["a","toto"],["c","bobo"],["f","coco"]]
            .fromPairs() // {"a":"toto","c":"bobo","f":"coco"}
            .value();
    const orderId = params.orderId;
    const paypalCost = params.paypal;
    const paymentRef = params.ref;

    const confirmedOrder = state.ebon.confirmedOrder;
    const partner = getPartner(state, confirmedOrder.partnerId);
    const partnerId = partner && partner.id;
    const partnerName = partner && partner.name;

    return {
        i18n: state.i18n,
        orderId,
        paypalCost,
        paymentRef,
        checkoutSessionId: params['cko-session-id'],
        checkoutPaymentId: params['cko-payment-id'],
        fetchingOrder: state.ebon.fetchOrder,
        confirmedOrder,
        partnerId,
        partnerName
    };
};

export default withRouter(connect(mapStateToProps)(ConfirmationEbonPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/ConfirmationEbonPage.js